export class SubscribedProduct {
  count: number;
  name: string;
  products: string[];
  subscriptionUuid: string;

  constructor(obj?: Partial<SubscribedProduct>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export interface GetSubscribedProductReq {
  includeAll: boolean;
  assigneed: string;
  subscriptionStatus: string;
}

export class SkuSubscription {
  constructor(
    public productId: string,
    public sku: string,
    public saleModelCode: string,
    public quota = 0
  ) {}
}

export class PurchaseSubscriptionRequest {
  skus: SkuSubscription[] = [];
  autoRenew: boolean;
  multiplier = 1;
  trial: boolean;
  invoiceNumber?: string | number;
  expiryDate?: string;
  contractNumber?: string;
  billingStartDate?: string;
}

export class PurchaseSubscriptionResponse {
  subscriptionUuid: string;
}

export class SubscriptionFilter {
  uuid?: string;
  number?: string;
  productIds?: string;
  statuses?: string;
  page?: number;
  perPage?: number;
  skuCodes?: string;
  embed?: string;
}

export class ProductSkusSubscription {
  constructor(
    public product: string,
    public sku: string,
    public copies: number,
    public contractNumber?: string,
    public isChunk?: boolean,
    public numberSku?: string
  ) {}
}

export class BillingSubscriptionRequest {
  productSkus: ProductSkusSubscription[] = [];
  autoRenew: boolean;
  multiplier = 1;
  trial: boolean;
  invoiceNumber?: string | number;
  startDate?: string;
  contractNumber?: string;
  endDate?: string;
  primaryProduct: string;
  primarySku: string;
  useYearlyModel: boolean;
  consumer: number;
}

export class SubscriptionInfo {
  product: string;
  sku: string;
  quantity: number;
  cost: PrictOrCost;
  price: PrictOrCost;

  constructor(item: Partial<SubscriptionInfo>) {
    if (item) {
      this.product = item.product;
      this.sku = item.sku;
      this.quantity = item.quantity ?? 1;
      this.cost = new PrictOrCost(item.cost ?? {});
      this.price = new PrictOrCost(item.price ?? {});
    }
  }

  get totalFinalPrice(): number {
    if (!this.price) return 0;
    return round(this.price.finalPrice * (round(this.quantity) ?? 1));
  }
}

export class PrictOrCost {
  currency: string;
  unitAmount: number;
  unitDiscount: number;
  taxRate: number;
  productName: string;
  skuName: string;
  totalAmount: number;

  constructor(item: Partial<PrictOrCost>) {
    if (item) {
      Object.assign(this, item);
    }
  }

  get finalPrice(): number {
    const price = this.unitAmount * (1 + (this.taxRate ?? 0));
    return round(price);
  }
}

function round(value: number, digits: number = 4): number {
  return Math.round((value + Number.EPSILON) * Math.pow(10, digits)) / Math.pow(10, digits);
}
